// extracted by mini-css-extract-plugin
export var divider = "_ot-0";
export var systemMessage = "_ot-1";